module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1023.2b88d92e.png";